import { useRef } from "react";

import { MarkdownToolbar } from "./MarkdownToolbar";

type Props = {
  value: string;
  onChange: (s: string) => void;
  placeholder?: string;
  rows?: number;
};

export function ParagraphEditor({
  value,
  onChange,
  placeholder,
  rows = 8,
}: Props) {
  const ref = useRef<HTMLTextAreaElement>(null);
  return (
    <div className="paragraph-editor">
      <MarkdownToolbar value={value} onChange={onChange} textareaRef={ref} />
      <textarea
        ref={ref}
        rows={rows}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
    </div>
  );
}
